import {ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import {ProductService} from '../../services/product.service';
import {ActivatedRoute, Router} from '@angular/router';
import {IonicModule} from '@ionic/angular';
import {isPlatformBrowser, NgForOf, NgIf} from '@angular/common';
import {SwiperComponent, SwiperModule} from 'swiper_angular';
import Swiper, {Lazy, SwiperOptions, Thumbs, Zoom} from 'swiper';
import {ProductSwiperComponent} from '../../helpers/product-swiper/product-swiper.component';
import {FooterComponent} from '../../helpers/footer/footer.component';
import {SubService} from '../../services/sub.service';
import {ArbameService} from '../../services/arbame.service';
import {FormsModule} from '@angular/forms';
import {NgxMaskDirective} from 'ngx-mask';
import {ToastService} from '../../services/toast.service';
import {Meta, Title} from '@angular/platform-browser';

Swiper.use([Thumbs, Lazy, Zoom]);

@Component({
  selector: 'app-product',
  templateUrl: './product.page.html',
  styleUrls: ['./product.page.scss'],
  standalone: true,
  imports: [
    IonicModule,
    NgForOf,
    NgIf,
    NgxMaskDirective,
    SwiperModule,
    ProductSwiperComponent,
    FooterComponent,
    FormsModule,
  ],
})
export class ProductPage implements OnInit, OnDestroy {
  requestedProductId;
  paramSub;
  appInitSub;

  constructor(private router: Router, @Inject(PLATFORM_ID) public platformId: any, private meta: Meta, private titleService: Title, private ts: ToastService, private productService: ProductService, private aService: ArbameService, private route: ActivatedRoute, private sub: SubService, private cdr: ChangeDetectorRef) {
    this.paramSub = this.route.params
      .subscribe(params => {

          // @ts-ignore
          this.requestedProductId = params.id;
          // @ts-ignore
          this.loadData(this.requestedProductId);
          console.log(this.requestedProductId);
        },
      );
    this.appInitSub = this.sub.appInitData.subscribe((data) => {
      if (!this.appInitData && data) {
        this.appInitData = data;
        this.loadData(this.requestedProductId);

      }
      this.appInitData = data;

    });
  }

  ngOnDestroy(): void {

  }

  ngOnInit() {
    if (this.paramSub) {
      this.paramSub.unsubscribe();
    }
    if (this.appInitSub) {
      this.appInitSub.unsubscribe();
    }
  }

  productData: any;
  similarProducts: any;
  fields;

  loadData(id: any) {
    if (!id) {
      return;

    }
    this.productService.getProduct(id).subscribe((data) => {
      this.productData = data;
      this.loadMetaTags();
      this.selectProductToShow(this.productData.data.products[0]);
      this.productArray = [this.productData.data.products[0].id];
      // this.refactorProduct();
      this.fields = this.refactorProduct();
      if (isPlatformBrowser(this.platformId)) {
        this.productService.getSimilar(id).subscribe((data) => {
          this.similarProducts = data;
        });
      }

    });
  }

  loadMetaTags() {
    let title = 'Arbame | ' + this.productData.data.title;
    let image = 'https://arbame.com/assets/img/logo.png';
    if (this.productData?.data?.files?.length > 0) {
      image = this.productData?.data?.files[0].thumb_url;
    }

    let keyword = 'arbame';
    this.productData.data.tree.forEach((item) => {
      keyword = keyword + item.title + ',';
    });
    this.titleService.setTitle(title);
    let currentUrl = `https://arbame.com/` + this.router.url;
    let description = this.productData.data.description.length < 255 ? this.productData.data.description : this.productData.data.description.toString().substring(0, 255);
    this.meta.updateTag({name: 'twitter:description', content: description});
    this.meta.updateTag({
      name: 'twitter:title',
      content: title,
    });
    this.meta.updateTag({name: 'thumbnail', content: image});
    this.meta.updateTag({name: 'twitter:site', content: title});
    this.meta.updateTag({name: 'twitter:image', content: image});

    this.meta.updateTag({name: 'twitter:card', content: 'summary'});
    this.meta.updateTag({name: 'twitter:url', content: currentUrl});

    this.meta.updateTag({name: 'description', content: description});
    this.meta.updateTag({name: 'keywords', content: keyword});
    this.meta.updateTag({
      name: 'title',
      content: title,
    });
    this.meta.updateTag({name: 'image', content: image});
    this.meta.updateTag({name: 'url', content: currentUrl});

    this.meta.updateTag({
      property: 'og:title',
      content: title,
    });
    this.meta.updateTag({property: 'og:description', content: description});
    this.meta.updateTag({property: 'og:image', image});
    this.meta.updateTag({property: 'og:url', content: currentUrl});
    // }
  }

  count = 0;
  // refactorProduct() {
  //     let foundItems: any = [];
  //     this.productData.data.products.forEach((product) => {
  //         product.items.forEach((item) => {
  //             let checkItemAdded = false;
  //             foundItems.forEach((addedItem: any) => {
  //                 if (addedItem.field === item.field) {//check field existence in added items
  //
  //                     if (!addedItem.values) {// initialize array for each field values
  //                         addedItem.values = [];
  //                     }
  //                     let valueAddedToFoundItem = false;
  //                     let index;//hold the current index either with found or with create
  //                     addedItem.values.forEach((value,i) => {//check each value of this field that is already added to refactored items
  //                         this.count++;
  //                         if (value.value === item.item_value) {
  //                             valueAddedToFoundItem = true;
  //                             index=i
  //                         }
  //                     });
  //
  //                     if (!valueAddedToFoundItem) {//check current item value added or not
  //                         index= addedItem.values.push({value: item.item_value, products: []});
  //                         index--;//need a mines one because it returns the next index on create
  //                         let productAddedToItem = false;
  //                         addedItem.values[index].products.forEach((productId) => {//check added product to this item value
  //                             this.count++;
  //                             if (productId === product.id) {
  //                                 productAddedToItem = true;
  //                             }
  //                         });
  //                         if (!productAddedToItem) {//if not added ,add it
  //                             addedItem.values[index].products.push(product.id);
  //                         }
  //                     }else{//if already added use found index for manipulation add adding product
  //                         let productAddedToItem = false;
  //                         addedItem.values[index].products.forEach((productId) => {
  //                             if (productId === product.id) {
  //                                 this.count++;
  //                                 productAddedToItem = true;
  //                             }
  //                         });
  //                         if (!productAddedToItem) {//if not added ,add it
  //                             addedItem.values[index].products.push(product.id);
  //                         }
  //                     }
  //                     checkItemAdded = true;
  //                 }
  //
  //
  //             });
  //             if (!checkItemAdded) {//gather all unique item grouped by field title in an array
  //                 foundItems.push(item);
  //             }
  //             console.log(foundItems);
  //         });
  //     });
  // }
  canShowVertical = false;
  configVertical: SwiperOptions = {
    slidesPerView: 5.5,
    spaceBetween: 15,
    watchSlidesProgress: true,
    pagination: true,
  };
  @ViewChild('thumb_swiper') thumbSwiper?: SwiperComponent;
  config: SwiperOptions;

  refactorProduct() {
    const foundItems = new Map<string, { field: string, values: { value: string, products: number[] }[] }>();

    this.productData.data.products.forEach((product) => {
      product.items.forEach((item) => {
        if (!foundItems.has(item.field)) {
          // Initialize the field if not present
          foundItems.set(item.field, {field: item.field, values: []});
        }

        const fieldData = foundItems.get(item.field)!;

        // Find or add the value to the field
        let valueEntry = fieldData.values.find(v => v.value === item.item_value);
        if (!valueEntry) {
          valueEntry = {value: item.item_value, products: []};
          fieldData.values.push(valueEntry);
        }

        // Add the product ID to the value if not already added
        if (!valueEntry.products.includes(product.id)) {
          valueEntry.products.push(product.id);
        }
      });
    });

    // Convert Map to Array for final result if needed
    return Array.from(foundItems.values());
  }


  FieldValueSelected(value: any, item) {
    let prev: boolean = value.selected;
    item.values.forEach((v) => {
      v.selected = false;
    });
    value.selected = !prev;
    item.hasSelected = item.values.some(i => i.selected);

    let selectedProducts: number[][] = [];

// Collect selected products
    this.fields.forEach((f) => {
      f.values.forEach((v) => {
        if (v.selected) {
          selectedProducts.push(v.products); // Ensure `v.products` is an array
        }
      });
    });

// Find the intersection of all arrays
    this.productArray = selectedProducts.reduce((acc, curr) =>
      acc.filter(num => curr.includes(num)),
    );
    if (this.productArray.length === 1) {

      this.productData?.data?.products.forEach((p) => {
        if (p.id === this.productArray[0]) {
          this.selectedProductToShowDetail = p;
        }
      });
      this.selectedProductToShowDetail.items.forEach((item) => {
        if (item.field === 'Price') {
          this.selectedProductToShowDetail.price = item.item_value;
        }
        if (item.field === 'MSRP') {
          this.selectedProductToShowDetail.msrp = item.item_value;
        }
      });
    } else {
      this.selectedProductToShowDetail = null;
    }
  }

  productArray: any = [];

  checkProductAvailability(product: any) {
    return this.productArray.includes(product.id);
  }

  checkItemAvailability(item: any) {

    return this.productArray.some(r => item.products.includes(r));
  }

  selectedProductToShowDetail;
  configSkeleton = {
    slidesPerView: 1,
    pagination: false,
    navigation: false,
    spaceBetween: 0,
  };

  selectProductToShow(product: any) {
    this.selectedProductToShowDetail = product;
    this.selectedProductToShowDetail.items.forEach((item) => {
      if (item.field === 'Price') {
        this.selectedProductToShowDetail.price = item.item_value;
      }
      if (item.field === 'MSRP') {
        this.selectedProductToShowDetail.msrp = item.item_value;
      }
    });
    this.productArray = [product.id];
  }

  onScroll($event) {
    if (document.querySelector('.header')) {
      if ($event.detail.scrollTop > 120) {
        document.querySelector('.header')?.classList.add('sticky-bar');
      } else {
        document.querySelector('.header')?.classList.remove('sticky-bar');
      }
    }
  }

  isLoading: boolean = false;

  addToCart() {
    this.isLoading = true;
    setTimeout(() => {
      this.isLoading = false;
    }, 500);
    const fd = new FormData();
    fd.append('product_id', this.selectedProductToShowDetail.id);
    fd.append('amount', this.quantityInput.toString());
    let groupId = localStorage.getItem('cgi');
    if (groupId) {
      fd.append('cart_group_id', groupId);
    }
    this.aService.addToBasket(fd).subscribe((data) => {
      this.ts.SuccessToast('Added to Cart');
      localStorage.setItem('cgi', data.data.cart_group.id);
      this.sub.cart.next(data.data.cart_group);
      this.sub.countCart.next(data?.data?.cart_group?.cart_items?.length ? data?.data?.cart_group?.cart_items?.length : 0);
    }, error => {
      if (error.error.message === 'out of stock') {
        this.ts.ErrorToast('Out of Stock');
      }
    });
  }

  thumbSwiperElement: Swiper;
  quantityInput = 1;
  isLogin = true;
  appInitData: any;

  thumbNext() {

    this.thumbSwiperElement.slideNext();
  }

  thumbPrev() {
    this.thumbSwiperElement.slidePrev();
  }

  thumbInit($event: [swiper: Swiper]) {
    this.thumbSwiperElement = $event[0];
    this.config = {
      slidesPerView: 1,
      lazy: {
        enabled: true,
        checkInView: true,
        loadPrevNext: true,
        loadPrevNextAmount: 1,
      },
      thumbs: {swiper: $event[0]},
      pagination: false,

      zoom: true,
      spaceBetween: 0,
    };
  }

  activeIndexChange() {
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 50);
  }

  registerTrader() {
    this.sub.joinTrade.next(true);
  }

  changeQty(number) {
    if ((+this.quantityInput + number) > 1) {
      this.quantityInput = +this.quantityInput + number;
    } else {
      this.quantityInput = 1;
    }

  }

  itemExist() {
    this.selectedProductToShowDetail.amount > 0;
  }

  clearSelection() {
    this.fields.forEach((item) => {
      item.selectedValue = null;
      item.values.forEach(v => v.selected = null);
      item.hasSelected = null;
    });
    this.productArray = [this.productData?.data?.products[0].id];
    this.selectedProductToShowDetail = this.productData?.data?.products[0];
  }

  redirectToCatalog(i) {

    if (i === 0) {
      this.router.navigate([`/products/${this.productData?.data?.tree[0].title_alias}/collection`]);

    }
    if (i === 1) {
      this.router.navigate([`/products/${this.productData?.data?.tree[0].title_alias}/${this.productData?.data?.tree[1].title_alias}`]);

    }
    if (i === 2) {
      // this.router.navigate([`/products/${this.productData?.data?.tree[0].title_alias}/${this.productData?.data?.tree[1].title_alias}/${this.productData?.data?.tree[2].title_alias}`]);

    }
  }


  sortArray(item: any): any[] {
    if (!item.sorted) {
      item.values = [...item.values].sort((a, b) => {
        const valA = a.value;
        const valB = b.value;

        const isNumericA = !isNaN(valA) && valA !== null && valA !== '';
        const isNumericB = !isNaN(valB) && valB !== null && valB !== '';

        if (isNumericA && isNumericB) {
          return parseFloat(valA) - parseFloat(valB);
        }

        return String(valA).localeCompare(String(valB));
      });

      item.sorted = true;
    }

    return item.values;
  }

}
